import { environment } from '../../../environments/environment';

export const apiBaseUrl = environment.apiUrl;

export const apiEndpoints = {
  users: `${apiBaseUrl}/v1.0/utente`,
  companies: `${apiBaseUrl}/v1.0/azienda/`,
  catalog: `${apiBaseUrl}/api/v1/ecommerce/catalog`,
  carts: `${apiBaseUrl}/api/v1/ecommerce/carts`,
  orders: `${apiBaseUrl}/api/v1/ecommerce/orders`,
  invoices: `${apiBaseUrl}/api/v1/ecommerce/invoices`,
  licenses: `${apiBaseUrl}/api/v1/ecommerce/licenses`,
  trialPayments: `${apiBaseUrl}/api/v1/ecommerce/trial-payments`,
  auth: `${apiBaseUrl}/api/v1/ecommerce/auth`,
} as const;
